import React, { useEffect, useState } from "react";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import Activity from "components/ui/Activity/Activity";
import apiClient from "lib/api-client";
import { formatTime } from "utils/formatTime";
import { formatActivityDate } from "utils/formatDate";

const formattedDateTime = (oldDate) => {
  const formatedDate = new Date(
    new Date(
      new Date(oldDate).toLocaleString("en-US", {
        timeZone: "Asia/Kolkata",
      })
    )
  );

  const date = formatedDate.toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  });

  const time = formatedDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return {
    date,
    time,
  };
};

// const generatedActivityString = (data) => {
//   const { date, time } = formattedDateTime(data?.date);
//   return (
//     <div style={{ color: "#8B8B8B", fontSize: "16px", fontFamily: "Karla", fontWeight: 400, lineHeight: "18.7px" }}>
//       <span style={{ color: "#FFFFFF" }}>{data.actionType}:</span> On {date} at {time},{data.user}
//       <span style={{ color: "#FFFFFF" }}> {data.action}</span> the {data.whatDo}
//     </div>
//   );
// };

const generatedActivityString = (data) => {
  if (data.action === "login" || data.action === "logout") {
    let name = data.action === "login" ? "Log - in" : "Log - out";
    return (
      <div style={{ color: "#8B8B8B", fontSize: "16px", fontFamily: "Karla", fontWeight: 400, lineHeight: "18.7px" }}>
        <span style={{ color: "#FFFFFF" }}>{data.actionType}:</span> On {data.date} at {data.time},{data.user} successfully
        <span style={{ color: "#FFFFFF" }}> {name}</span> {data.whatDo}
      </div>
    );
  } else if (data.action === "placedAnOrder") {
    return (
      <div style={{ color: "#8B8B8B", fontSize: "16px", fontFamily: "Karla", fontWeight: 400, lineHeight: "18.7px" }}>
        <span style={{ color: "#FFFFFF" }}>{data.actionType}:</span> On {data.date} at {data.time},{data.user}
        <span style={{ color: "#FFFFFF" }}> {"Placed an order"}</span> {data.whatDo}
      </div>
    );
  } else {
    return (
      <div style={{ color: "#8B8B8B", fontSize: "16px", fontFamily: "Karla", fontWeight: 400, lineHeight: "18.7px" }}>
        <span style={{ color: "#FFFFFF" }}>{data.actionType}:</span> On {formatActivityDate(data.date)} at {formatTime(data.time)},{data.user}
        <span style={{ color: "#FFFFFF" }}> {data.action}</span> the
        {data.whatDo}
      </div>
    );
  }
};

const MainActivity = () => {
  const [activityData, setActivityData] = useState([]);

  const fetchData = async () => {
    try {
      // const res = await axios.get(`${config.baseUrl}/api/v1/logs/main-activity-log`);
      const res = await apiClient.get(`api/v1/logs/main-activity-log`);
      return res?.data?.mainLogs || [];
    } catch (error) {
      console.error("Error fetching activity data:", error);
      return [];
    }
  };

  useEffect(() => {
    const getLogs = async () => {
      const logsData = await fetchData();
      setActivityData(logsData);
    };
    getLogs();
  }, []);

  return (
    <>
      {activityData.length > 0 ? (
        <div>
          <Activity activityData={activityData} generatedActivityString={generatedActivityString} />
        </div>
      ) : (
        <div style={{ display: "flex", textAlign: "center", padding: "40px", justifyContent: "center", alignItems: "center" }}>
          <Background />
        </div>
      )}
    </>
  );
};

export default MainActivity;
